import { useState } from 'react';
import PropTypes from 'prop-types';
import './Tabs.css';

export default function Tabs({
    tabs,
    defaultTab,
    onChange,
    variant = 'default',
    className = ''
}) {
    const [activeTab, setActiveTab] = useState(defaultTab || tabs[0]?.key);

    const handleTabClick = (key) => {
        setActiveTab(key);
        onChange?.(key);
    };

    const activeContent = tabs.find((t) => t.key === activeTab)?.content;

    return (
        <div className={`tabs tabs-${variant} ${className}`}>
            <div className="tabs-header">
                {tabs.map((tab) => (
                    <button
                        key={tab.key}
                        className={`tab-item ${activeTab === tab.key ? 'active' : ''}`}
                        onClick={() => handleTabClick(tab.key)}
                        disabled={tab.disabled}
                    >
                        {tab.icon && <tab.icon size={16} />}
                        <span>{tab.label}</span>
                        {tab.badge !== undefined && (
                            <span className="tab-badge">{tab.badge}</span>
                        )}
                    </button>
                ))}
            </div>
            <div className="tabs-content">{activeContent}</div>
        </div>
    );
}

Tabs.propTypes = {
    tabs: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        icon: PropTypes.elementType,
        content: PropTypes.node,
        badge: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        disabled: PropTypes.bool
    })).isRequired,
    defaultTab: PropTypes.string,
    onChange: PropTypes.func,
    variant: PropTypes.oneOf(['default', 'pills', 'underline']),
    className: PropTypes.string
};
